/** Returns a same-origin relative path suitable for post-login redirect, or
 * null if the value is missing/unsafe (open-redirect protection). */
export function safeReturnUrl(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('://')) {
    return null;
  }
  return value;
}
